import HeroSectionWithButton from "../SkillAnalytics/Components/HeroSectionWithButton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ShowcaseSection from "../SkillAnalytics/Components/ShowcaseSection";
import { useTranslation } from "react-i18next";

const SkillManagement = () => {
  const { t } = useTranslation();

  const showcaseList = [
    {
      icon: "service-talent-acquisition",
      text: t("landing.skillManagement.showcase.talentAcquisition"),
    },
    {
      icon: "service-candidate-experience",
      text: t("landing.skillManagement.showcase.candidateExperience"),
    },
    {
      icon: "service-succession-planning",
      text: t("landing.skillManagement.showcase.successionPlanning"),
    },
  ];
  return (
    <div className={"p-0"}>
      <HeroSectionWithButton
        imageSrc={"/LandingPageImages/office.webp"}
        isImageOnRight={true}
        headerText={t("landing.skillManagement.hero.title")}
      >
        {t("landing.skillManagement.hero.description")}
      </HeroSectionWithButton>

      <Row className={"justify-content-center text-center mx-0"}>
        <Col xs={"auto"} className={"mt-5 EB-Garamond text-36 text-lg-50"}>
          {t("landing.skillManagement.servicesTitle")}
        </Col>
      </Row>

      <ShowcaseSection showcaseList={showcaseList} xs={12}></ShowcaseSection>
    </div>
  );
};
export default SkillManagement;
